export interface Vehicle {
  id: number
  image: string
  gallery: string[]
  year: string
  make: string
  model: string
  trim: string
  price: string
  mileage: string
  engine: string
  transmission: string
  fuel: string
  color: string
  description: string
  equipment: string[]
  type: string
  sold?: boolean
}

export const vehicles: Vehicle[] = [
  {
    id: 1,
    image:
      'https://cdn.magicpatterns.com/uploads/wPpberexdfWez1T3wBYz6w/IMG_5684.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/wPpberexdfWez1T3wBYz6w/IMG_5684.jpg',
      'https://cdn.magicpatterns.com/uploads/rN3dXY6MsFEpNZbazKkPxW/IMG_5687.jpg',
      'https://cdn.magicpatterns.com/uploads/dzY5Cat7kJeJEfAvDk6Zr3/IMG_5688.jpg',
      'https://cdn.magicpatterns.com/uploads/aWw9JvDudUXSxn5864QELW/IMG_5689.jpg',
      'https://cdn.magicpatterns.com/uploads/opoSXyBrcwNhd6qBTFJoSc/IMG_5690.jpg',
      'https://cdn.magicpatterns.com/uploads/bwcyR3BbtKtN1oDPbdym4G/IMG_5691.jpg',
      'https://cdn.magicpatterns.com/uploads/phztmvRJ2yfc59ediWRith/IMG_5692.jpg',
    ],
    year: '2021',
    make: 'Ford',
    model: 'Ranger',
    trim: 'XL',
    price: 'USD 19.990',
    mileage: '130.000 km',
    engine: '3.2L Puma TDCi',
    transmission: 'Automática 6 vel.',
    fuel: 'Diésel',
    color: 'Gris Plata',
    description:
      'Excelente estado, único dueño. Mantenimientos al día en concesionario oficial. Ideal para trabajo y familia. Cuenta con accesorios originales Ford.',
    equipment: [
      'Llantas de aleación 17"',
      'Pantalla táctil 8" con SYNC 3',
      'Cámara de retroceso',
      'Sensores de estacionamiento',
      'Control de velocidad crucero',
      'Climatizador automático bizona',
    ],
    type: 'Camionetas',
    sold: true,
  },
  {
    id: 4,
    image:
      'https://cdn.magicpatterns.com/uploads/kdpLcVULHCKYQvUjq7F78z/IMG_8065.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/kdpLcVULHCKYQvUjq7F78z/IMG_8065.jpg',
      'https://cdn.magicpatterns.com/uploads/gc6T54U2mvp2Nxooeriryh/IMG_8066.jpg',
      'https://cdn.magicpatterns.com/uploads/9LfJWWnGKUuhV3A1eVASdh/IMG_8067.jpg',
      'https://cdn.magicpatterns.com/uploads/hs3pSke6N9QKVyk2MYeit8/IMG_8068.jpg',
      'https://cdn.magicpatterns.com/uploads/vE7Ss7hHJonhCceXsSQUgf/IMG_8069.jpg',
      'https://cdn.magicpatterns.com/uploads/qEqY2H2KiVEHN8rpyvzAU6/IMG_8070.jpg',
    ],
    year: '2023',
    make: 'Volkswagen',
    model: 'Amarok',
    trim: 'V6 Extreme',
    price: 'USD 39.900',
    mileage: '20.000 km',
    engine: '3.0L V6 TDI',
    transmission: 'Automática 8 vel.',
    fuel: 'Diésel',
    color: 'Gris Indio',
    description:
      'Volkswagen Amarok V6 Extreme, la pick-up tope de gama. Tracción integral 4MOTION permanente, motor V6 turbodiésel de gran potencia y torque. Equipamiento full, llantas negras y cobertor de caja. Excelente estado.',
    equipment: [
      'Tracción integral 4MOTION',
      'Llantas de aleación negras 20"',
      'Cobertor de caja roll-bar',
      'Estribos laterales de aluminio',
      'Faros Full LED',
      'Climatizador automático bizona',
      'Sistema multimedia con cámara de retroceso',
      'Tapizado de cuero',
    ],
    type: 'Camionetas',
    sold: true,
  },
  {
    id: 5,
    image:
      'https://cdn.magicpatterns.com/uploads/bLznik32aKxeXqVtP78zsf/IMG_0210.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/bLznik32aKxeXqVtP78zsf/IMG_0210.jpg',
      'https://cdn.magicpatterns.com/uploads/14HDyrbyrpaXrziGDmMW3M/IMG_0211.jpg',
      'https://cdn.magicpatterns.com/uploads/bKVQUbTUmUMdtHaz6zHa9U/IMG_0212.jpg',
      'https://cdn.magicpatterns.com/uploads/pfrWaDrtLoKvCq57TZJG2U/IMG_0213.jpg',
      'https://cdn.magicpatterns.com/uploads/tuKBs3Bsq5vi8QjBBoA8hB/IMG_0214.jpg',
      'https://cdn.magicpatterns.com/uploads/xhnd1MfLBgpbZ1NKb4FP2C/IMG_0215.jpg',
      'https://cdn.magicpatterns.com/uploads/ieJUwnP5rgpnsr47291SBn/IMG_0216.jpg',
    ],
    year: '1979',
    make: 'Fiat',
    model: '600',
    trim: 'S',
    price: 'USD 9.000',
    mileage: '56.000 km',
    engine: '0.8L 4 cilindros',
    transmission: 'Manual 4 vel.',
    fuel: 'Nafta',
    color: 'Amarillo',
    description:
      'Clásico Fiat 600 S en excelente estado de conservación. Pintura original amarilla impecable, motor funcionando a la perfección. Una verdadera joya de colección, ideal para los amantes de los autos antiguos.',
    equipment: [
      'Motor trasero refrigerado por aire',
      'Pintura original conservada',
      'Tapizados en buen estado',
      'Documentación al día',
      'Llantas de época',
      'Detalles cromados originales',
    ],
    type: 'Deportivos',
    sold: true,
  },
  {
    id: 6,
    image:
      'https://cdn.magicpatterns.com/uploads/mxdkvWEirrUKtDD3G5YkNU/IMG_8059.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/mxdkvWEirrUKtDD3G5YkNU/IMG_8059.jpg',
      'https://cdn.magicpatterns.com/uploads/1UUjAvJJMP2QAUfqo38wvs/IMG_8060.jpg',
      'https://cdn.magicpatterns.com/uploads/sePZNZrYgRyRoj3LjQZVFW/IMG_8061.jpg',
      'https://cdn.magicpatterns.com/uploads/3TdEJAJFUV19Jr1v2DdvMN/IMG_8062.jpg',
      'https://cdn.magicpatterns.com/uploads/4QMRwetqGw1MJPghNeMLWx/IMG_8063.jpg',
      'https://cdn.magicpatterns.com/uploads/6HP2wFDKYjgfZgJ9oRojAT/IMG_8046.jpg',
      'https://cdn.magicpatterns.com/uploads/mPWjHnHjqRuTAdbC6Lq2bD/IMG_8064.jpg',
    ],
    year: '2015',
    make: 'Ford',
    model: 'Focus',
    trim: 'SE Plus AT',
    price: 'USD 13.000',
    mileage: '140.000 km',
    engine: '2.0L Duratec',
    transmission: 'Automática 6 vel.',
    fuel: 'Nafta',
    color: 'Gris Plata',
    description:
      'Ford Focus SE Plus con caja automática, full equipo. Muy buen estado general, motor 2.0 nafta. Ideal primer auto o uso familiar. Mantenimientos al día.',
    equipment: [
      'Caja automática de 6 velocidades',
      'Climatizador automático',
      'Pantalla multimedia con Bluetooth',
      'Llantas de aleación',
      'Sensores de estacionamiento traseros',
      'Control de velocidad crucero',
      'Faros antiniebla',
      'Tapizado de cuero',
    ],
    type: 'Hatchbacks',
  },
  {
    id: 7,
    image:
      'https://cdn.magicpatterns.com/uploads/2X2AA6SyiuCCGYUoerqVMp/IMG_8092.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/2X2AA6SyiuCCGYUoerqVMp/IMG_8092.jpg',
      'https://cdn.magicpatterns.com/uploads/nsJDmipp3m1wMj7KweU9dM/IMG_8093.jpg',
      'https://cdn.magicpatterns.com/uploads/uXAy2Zk1XcVX52AZTc5JWo/IMG_8094.jpg',
      'https://cdn.magicpatterns.com/uploads/gfnbws8N8fzUMuVUy88YcD/IMG_8095.jpg',
      'https://cdn.magicpatterns.com/uploads/g3LZNbReKrzRQ4sVwZY2F9/IMG_8096.jpg',
      'https://cdn.magicpatterns.com/uploads/tLv9xLf3Q8sYj1iyVqUkRy/IMG_8082.jpg',
      'https://cdn.magicpatterns.com/uploads/qujUJtpDm4m6dp3S12r4qG/IMG_8097.jpg',
    ],
    year: '2012',
    make: 'Fiat',
    model: '500',
    trim: 'Sport',
    price: 'USD 11.000',
    mileage: '90.000 km',
    engine: '1.4L 16v',
    transmission: 'Manual',
    fuel: 'Nafta',
    color: 'Blanco',
    description:
      'Fiat 500 Sport en excelente estado. Diseño icónico, llantas deportivas y tapizado combinado en negro y rojo. Ideal para ciudad, económico y muy divertido de manejar. Mantenimientos al día.',
    equipment: [
      'Llantas de aleación deportivas',
      'Tapizado deportivo negro/rojo',
      'Aire acondicionado',
      'Dirección asistida',
      'Levantavidrios eléctricos',
      'Cierre centralizado',
      'Equipo de música con Bluetooth',
      'Airbags frontales',
    ],
    type: 'Coupés',
  },
]
